import { useEffect } from "react";

function Project() {
  const windowValue = () => {
    let data = document.documentElement.scrollTop;
    
    // project 1 food
    let food_img_id = document.getElementById("food_img_id");
    let food_text_id = document.getElementById("food_text_id");

    // project 2 momo
    let momo_text_id = document.getElementById("momo_text_id");
    let momo_img_id = document.getElementById("momo_img_id");

    // project 3 50 projects
    let projects_img_id = document.getElementById("projects_img_id");
    let projects_text_id = document.getElementById("projects_text_id");

    // project 4 quiz
    let quiz_text_id = document.getElementById("quiz_text_id");
    let quiz_img_id = document.getElementById("quiz_img_id");

    // project 5 recipe
    let recipe_img_id = document.getElementById("recipe_img_id");
    let recipe_text_id = document.getElementById("recipe_text_id");

    // project 6 todo
    let todo_img_id = document.getElementById("todo_img_id");
    let todo_text_id = document.getElementById("todo_text_id");

    // project 1 food app
    if (data > 800) {
      food_img_id.classList.add("odd_Animation_img");
      food_text_id.classList.add("odd_Animation_text");
    } else {
      food_img_id.classList.remove("odd_Animation_img");
      food_text_id.classList.remove("odd_Animation_text");
    }

    // project 2 momo restaurant
    if (data > 1150) {
      momo_img_id.classList.add("even_Animation_img");
      momo_text_id.classList.add("even_Animation_text");
    } else {
      momo_img_id.classList.remove("even_Animation_img");
      momo_text_id.classList.remove("even_Animation_text");
    }

    // project 3 50 projects
    if (data > 1600) {
      projects_img_id.classList.add("odd_Animation_img");
      projects_text_id.classList.add("odd_Animation_text");
    } else {
      projects_img_id.classList.remove("odd_Animation_img");
      projects_text_id.classList.remove("odd_Animation_text");
    }

    // project 4 quiz
    if (data > 2000) {
      quiz_text_id.classList.add("even_Animation_text");
      quiz_img_id.classList.add("even_Animation_img");
    } else {
      quiz_text_id.classList.remove("even_Animation_text");
      quiz_img_id.classList.remove("even_Animation_img");
    }

    // project 5 recipe
    if (data > 2820) {
      recipe_img_id.classList.add("odd_Animation_img");
      recipe_text_id.classList.add("odd_Animation_text");
    } else {
      recipe_img_id.classList.remove("odd_Animation_img");
      recipe_text_id.classList.remove("odd_Animation_text");
    }

    // project 6 todo
    if (data > 3220) {
      todo_img_id.classList.add("even_Animation_img");
      todo_text_id.classList.add("even_Animation_text");
    } else {
      todo_text_id.classList.remove("even_Animation_text");
      todo_img_id.classList.remove("even_Animation_img");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", windowValue);
    return () => {
      window.removeEventListener("scroll", windowValue);
    };
  }, []);

  return (
    <>
      <div className="parent_div" id="parent_div_id">
        <div className="parent_header">
          <h2>My Projects</h2>
          <div className="section_divider">
            <div className="divider_line"></div>
            <i className="fa-solid fa-code"></i>
            <div className="divider_line"></div>
          </div>
          <p className="section_subtitle">
            Each project is a unique piece of development
          </p>
        </div>

        {/* Project 1 food */}
        <div className="all_item_Outer_div">
          <div id="food_img_id" className="project_image_container">
            <img src="https://cdn.builtin.com/cdn-cgi/image/f=auto,fit=cover,w=1200,h=635,q=80/https://builtin.com/sites/www.builtin.com/files/food-delivery-companies.jpg" className="same_img_class" alt="Food Delivery Website" />
            <div className="image_overlay">
              <div className="tech_stack">
                <span>MERN Stack</span>
              </div>
            </div>
          </div>

          <div id="food_text_id">
            <div className="same_text_class">
              <div className="project_header">
                <h3>
                  Food Delivery Website
                  <i className="fa-solid fa-utensils"></i>
                </h3>
                <div className="project_number">01</div>
              </div>
              <p>
                Full-stack MERN food delivery platform enabling users to explore menus,
                order food, and chat with chefs in real time. Features include preordering,
                e-Sewa payment integration, cart management with Redux, order history tracking,
                and a "Find Your Friend" option to connect with other users.
              </p>
              <div className="tech_tags">
                <span>React</span>
                <span>Node.js</span>
                <span>Express</span>
                <span>MongoDB</span>
                <span>Redux</span>
                <span>e-Sewa</span>
              </div>

              <div className="source_code">
                <a
                  className="code_btn github"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/pramod-k-mahto/FoodDeliveryWebsite"
                >
                  <i className="fa-brands fa-github"></i> View Code
                </a>
                <a
                  className="code_btn demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://yummyfoodnepal.vercel.app/"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 2 Momo Restaurant */}
        <div className="all_item_Outer_div">
          <div id="momo_text_id">
            <div className="same_text_class">
              <div className="project_header">
                <h3>
                  Momo Restaurant
                  <i className="fa-solid fa-bowl-food"></i>
                </h3>
                <div className="project_number">02</div>
              </div>
              <p>
                MERN stack restaurant application specializing in momo (dumplings). 
                Features product filtering and searching, interactive menu, cart functionality, 
                and e-Sewa payment integration. Includes an admin dashboard for comprehensive 
                restaurant management.
              </p>
              <div className="tech_tags">
                <span>React</span>
                <span>Express</span>
                <span>MongoDB</span>
                <span>Node.js</span>
                <span>e-Sewa</span>
              </div>

              <div className="source_code">
                <a
                  className="code_btn github"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/pramod-k-mahto/momo-restaurant"
                >
                  <i className="fa-brands fa-github"></i> View Code
                </a>
                <a
                  className="code_btn demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://momo-restaurant-nepal.vercel.app/"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
          <div id="momo_img_id" className="project_image_container">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQ-fwgPGEU1rcfHczQvC77ykhUsdk-u0-Fsg&s" className="same_img_class" alt="Momo Restaurant" />
            <div className="image_overlay">
              <div className="tech_stack">
                <span>MERN Stack</span>
              </div>
            </div>
          </div>
        </div>

        {/* Project 3 50 Projects */}
        <div className="all_item_Outer_div">
          <div id="projects_img_id" className="project_image_container">
            <img src="https://img-c.udemycdn.com/course/480x270/3671332_b86a_4.jpg" className="same_img_class" alt="50 Days 50 Projects" />
            <div className="image_overlay">
              <div className="tech_stack">
                <span>React Collection</span>
              </div>
            </div>
          </div>
          <div id="projects_text_id">
            <div className="same_text_class">
              <div className="project_header">
                <h3>
                  50 Days 50 Projects
                  <i className="fa-solid fa-code"></i>
                </h3>
                <div className="project_number">03</div>
              </div>
              <p>
                A comprehensive collection of 50 mini-projects built over 50 days using React. 
                Each project showcases different React concepts, components, and techniques. 
                The collection includes various UI elements, animations, API integrations, 
                and interactive features.
              </p>

              <div className="tech_tags">
                <span>React</span>
                <span>CSS</span>
                <span>JavaScript</span>
                <span>APIs</span>
                <span>Hooks</span>
              </div>

              <div className="source_code">
                <a
                  className="code_btn github"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/pramod-k-mahto/50days-50projects"
                >
                  <i className="fa-brands fa-github"></i> View Code
                </a>
                <a
                  className="code_btn demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://50projects50days-react.vercel.app/"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 4 Quiz */}
        <div className="all_item_Outer_div">
          <div id="quiz_text_id">
            <div className="same_text_class">
              <div className="project_header">
                <h3>
                  Quiz Website
                  <i className="fa-solid fa-question"></i>
                </h3>
                <div className="project_number">04</div>
              </div>
              <p>
                Quiz platform crafted with React, CSS, Node.js, and MySQL. Delve
                into a wide array of quizzes, test user knowledge, and instantly
                view scores. As an admin, manage quizzes with ease—add new
                quizzes, update existing ones, and remove outdated content.
              </p>
              <div className="tech_tags">
                <span>HTML</span>
                <span>CSS</span>
                <span>JavaScript</span>
                <span>Node.js</span>
                <span>MySQL</span>
              </div>

              <div className="source_code">
                <a
                  className="code_btn github"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/pramod-k-mahto/quizapp"
                >
                  <i className="fa-brands fa-github"></i> View Code
                </a>
                <a
                  className="code_btn demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://nepquiz.vercel.app/"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
          <div id="quiz_img_id" className="project_image_container">
            <img src="https://www.bytewebster.com/img/javascript-quiz-image-bytewebster3.png" className="same_img_class" alt="Quiz Website" />
            <div className="image_overlay">
              <div className="tech_stack">
                <span>Full Stack</span>
              </div>
            </div>
          </div>
        </div>

        {/* Project 5 Recipe*/}
        <div className="all_item_Outer_div">
          <div id="recipe_img_id" className="project_image_container">
            <img src="https://cdn.prod.website-files.com/64f7240c8fa5d73376ca02b7/651afea503b49315ec74d0f9_NYTimes%20cooking%20section.webp" className="same_img_class" alt="Recipe Application" />
            <div className="image_overlay">
              <div className="tech_stack">
                <span>Full Stack</span>
              </div>
            </div>
          </div>
          <div id="recipe_text_id">
            <div className="same_text_class">
              <div className="project_header">
                <h3>
                  Recipe Application
                  <i className="fa-solid fa-book"></i>
                </h3>
                <div className="project_number">05</div>
              </div>
              <p>
                Recipe platform crafted with HTML, CSS, Node.js, and MySQL.
                Explore a vast collection of recipes, from traditional
                favorites to innovative dishes, and elevate users' culinary
                skills. As an admin, effortlessly manage recipes.
              </p>

              <div className="tech_tags">
                <span>HTML</span>
                <span>CSS</span>
                <span>JavaScript</span>
                <span>Node.js</span>
                <span>MySQL</span>
              </div>

              <div className="source_code">
                <a
                  className="code_btn github"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/pramod-k-mahto/Recipe-App-frontend-"
                >
                  <i className="fa-brands fa-github"></i> View Code
                </a>
                <a
                  className="code_btn demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://neprecipe.vercel.app/"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
        </div>

        {/*Todo App 6 */}
        <div className="all_item_Outer_div">
          <div id="todo_text_id">
            <div className="same_text_class">
              <div className="project_header">
                <h3>
                  Todo App
                  <i className="fa-solid fa-list-check"></i>
                </h3>
                <div className="project_number">06</div>
              </div>
              <p>
                ToDo application designed with HTML, CSS, Node.js, and MySQL.
                Easily manage your tasks with a user-friendly interface, add new
                tasks, update existing ones, and remove completed items
                effortlessly.
              </p>

              <div className="tech_tags">
                <span>HTML</span>
                <span>CSS</span>
                <span>JavaScript</span>
                <span>Node.js</span>
                <span>MySQL</span>
              </div>

              <div className="source_code">
                <a
                  className="code_btn github"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/pramod-k-mahto/todo-fronted"
                >
                  <i className="fa-brands fa-github"></i> View Code
                </a>
                <a
                  className="code_btn demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://neptodo.vercel.app/"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
          <div id="todo_img_id" className="project_image_container">
            <img src="https://images.ctfassets.net/lpvian6u6i39/GtD3qzHrBIgVZJNIJBlO0/8610e2883df2dec28305841aa1ddd2ae/todo-app.png" className="same_img_class" alt="Todo App" />
            <div className="image_overlay">
              <div className="tech_stack">
                <span>Full Stack</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .parent_div {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px 20px;
          overflow: hidden;
          font-family: 'Inter', 'Segoe UI', sans-serif;
          color: #333;
        }

        .parent_header {
          text-align: center;
          margin-bottom: 70px;
          position: relative;
        }

        .parent_header h2 {
          margin: 0;
          font-size: 36px;
          font-weight: 700;
          background: linear-gradient(135deg, #333, #6d6d6d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          position: relative;
          display: inline-block;
        }

        .section_divider {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 15px 0;
        }

        .divider_line {
          height: 2px;
          width: 60px;
          background: linear-gradient(90deg, rgba(151,151,151,0.1), rgba(151,151,151,0.6), rgba(151,151,151,0.1));
        }

        .section_divider i {
          margin: 0 15px;
          font-size: 18px;
          color: #666;
        }

        .section_subtitle {
          font-size: 16px;
          color: #666;
          font-weight: 400;
          margin-top: 5px;
        }

        .all_item_Outer_div {
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          margin: 120px 0;
          position: relative;
          gap: 40px;
        }

        .all_item_Outer_div:nth-child(even) {
          direction: rtl;
        }

        .all_item_Outer_div:nth-child(even) .same_text_class {
          direction: ltr;
        }

        .project_header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
          position: relative;
        }

        .project_header h3 {
          font-size: 24px;
          font-weight: 600;
          display: flex;
          align-items: center;
          margin: 0;
          color: #333;
        }

        .project_header h3 i {
          margin-left: 12px;
          color: #4a6cfa;
          font-size: 20px;
        }

        .project_number {
          font-size: 40px;
          font-weight: 800;
          opacity: 0.08;
          position: absolute;
          top: -30px;
          right: 0;
          z-index: -1;
        }

        .all_item_Outer_div:nth-child(even) .project_number {
          right: auto;
          left: 0;
        }

        .project_image_container {
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }

        .project_image_container:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.15);
        }

        .image_overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 50%);
          opacity: 0;
          transition: opacity 0.3s ease;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 20px;
        }

        .project_image_container:hover .image_overlay {
          opacity: 1;
        }

        .tech_stack {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          margin-bottom: 10px;
        }

        .tech_stack span {
          background: rgba(255,255,255,0.9);
          color: #333;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          margin-right: 8px;
          margin-bottom: 8px;
        }

        .same_img_class {
          height: auto;
          width: 100%;
          border-radius: 8px;
          transition: transform 0.5s ease;
          display: block;
          object-fit: cover;
          aspect-ratio: 16/10;
        }

        .same_text_class {
          height: auto;
          width: 100%;
          padding: 0 20px;
          text-align: left;
        }

        .same_text_class p {
          width: 100%;
          line-height: 1.7;
          margin-bottom: 20px;
          font-size: 16px;
          color: #555;
        }

        .tech_tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 20px;
        }

        .tech_tags span {
          display: inline-block;
          padding: 5px 12px;
          background-color: #f5f5f5;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 500;
          color: #333;
          transition: all 0.2s ease;
        }

        .tech_tags span:hover {
          background-color: #e5e5e5;
          transform: translateY(-2px);
        }

        .source_code {
          display: flex;
          gap: 15px;
          margin-top: 25px;
        }

        .code_btn {
          display: flex;
          align-items: center;
          padding: 8px 16px;
          border-radius: 6px;
          font-weight: 600;
          font-size: 14px;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .code_btn i {
          margin-right: 8px;
          font-size: 16px;
        }

        .code_btn.github {
          background-color: #333;
          color: white;
        }

        .code_btn.github:hover {
          background-color: #000;
          transform: translateY(-2px);
        }

        .code_btn.demo {
          background-color: #4a6cfa;
          color: white;
        }

        .code_btn.demo:hover {
          background-color: #3a5ae0;
          transform: translateY(-2px);
        }

        /* Animation classes */
        @keyframes Animation_odd_img {
          0% {
            transform: translateX(-100%) scale(0.95);
            opacity: 0;
          }
          100% {
            transform: translateX(0) scale(1);
            opacity: 1;
          }
        }

        .odd_Animation_img {
          animation: Animation_odd_img 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
        }

        @keyframes Animation_odd_text {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        .odd_Animation_text {
          animation: Animation_odd_text 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          animation-delay: 0.1s;
        }

        @keyframes Animation_even_img {
          0% {
            transform: translateX(100%) scale(0.95);
            opacity: 0;
          }
          100% {
            transform: translateX(0) scale(1);
            opacity: 1;
          }
        }

        .even_Animation_img {
          animation: Animation_even_img 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
        }

        @keyframes Animation_even_text {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        .even_Animation_text {
          animation: Animation_even_text 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          animation-delay: 0.1s;
        }

        /* Media Queries */
        @media (max-width: 992px) {
          .parent_header h2 {
            font-size: 32px;
          }
          
          .all_item_Outer_div {
            margin: 80px 0;
            gap: 30px;
          }
        }

        @media (max-width: 768px) {
          .parent_div {
            padding: 30px 15px;
          }
          
          .parent_header {
            margin-bottom: 50px;
          }
          
          .all_item_Outer_div {
            grid-template-columns: 1fr;
            margin: 60px 0;
            gap: 25px;
            direction: ltr;
          }
          
          .all_item_Outer_div:nth-child(even) {
            direction: ltr;
          }
          
          .project_number {
            font-size: 30px;
            top: -25px;
            right: 0;
          }
          
          .all_item_Outer_div:nth-child(even) .project_number {
            right: 0;
            left: auto;
          }
          
          /* Mobile animations */
          @keyframes Animation_odd_img {
            0% {
              transform: translateY(-30px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          @keyframes Animation_odd_text {
            0% {
              transform: translateY(30px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          @keyframes Animation_even_img {
            0% {
              transform: translateY(-30px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          @keyframes Animation_even_text {
            0% {
              transform: translateY(30px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          .odd_Animation_img, .even_Animation_img,
          .odd_Animation_text, .even_Animation_text {
            position: static;
          }
        }

        @media (max-width: 480px) {
          .parent_header h2 {
            font-size: 28px;
          }
          
          .section_subtitle {
            font-size: 14px;
          }
          
          .project_header h3 {
            font-size: 20px;
          }
          
          .project_number {
            font-size: 26px;
            top: -20px;
          }
          
          .same_text_class p {
            font-size: 15px;
          }
          
          .tech_tags span {
            font-size: 12px;
            padding: 4px 10px;
          }
          
          .source_code {
            flex-direction: column;
            gap: 12px;
          }
          
          .code_btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </>
  );
}

export default Project;